/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import dayjs from 'dayjs';
import { IHospital } from 'app/shared/model/hospital.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';

export interface IDentalExamAndTreatment {
  id?: string;
  examination?: boolean | null;
  treatment?: boolean | null;
  groupOnly?: boolean | null;
  groupName?: string | null;
  examName?: string | null;
  treatmentName?: string | null;
  active?: boolean | null;
  cursor?: number;
  lastUpdated?: dayjs.Dayjs | null;
  microSec?: dayjs.Dayjs | null;
  timestampEntry?: dayjs.Dayjs | null;
  addedByType?: keyof typeof AddedByType | null;
  addedByID?: string | null;
  modifiedByType?: keyof typeof AddedByType | null;
  modifiedByID?: string | null;
  hospital?: IHospital | null;
  group?: IDentalExamAndTreatment | null;
}

export const defaultValue: Readonly<IDentalExamAndTreatment> = {
  examination: false,
  treatment: false,
  groupOnly: false,
  active: false,
};
